// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GJvR","option":"styles_option__VCXhQ","selected":"styles_selected__3bbB4"};